<template>
    <div >
        <div class="tabArea">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="综合统计" name="first">
                    <div v-if="progressTypeDialogVisible" width="900px" top="120px">
                        <progressType ref="progressType" :listHeight="520" :ksnf="transksnf" :zydm="transzydm" :xz="transxz" @closeProgressTypeDialog="closeProgressTypeDialog"></progressType>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="课程占比" name="second">
                    <div v-if="pieChartDialogVisible" width="900px" top="120px">
                        <pieChart :chartData="chartData" :chartType="chartType" class="chartStyle"/>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import pieChart from "./pieChart.vue";
    import progressType from "./progressType.vue";

    export default {
        components: {
            pieChart,
            progressType,
        },
        props: ['listHeight','ksnf','zydm','xz'],
        data() {
            return {
                transksnf: this.ksnf,
                transzydm: this.zydm,
                transxz: this.xz,
                pieChartDialogTitle: '课程类型统计',
                pieChartDialogVisible: false,
                timeStamp: '',
                chartType:'bing',
                chartData: [],
                progressTypeDialogVisible: true,
                progressTypeWidth: '',
                activeName: 'first',
            }
        },
        mounted() {

        },
        methods: {
            handleClick(tab, event) {
                if(tab.name=="first"){
                    this.showProgressType();
                }else if(tab.name=="second"){
                    this.showPieChart();
                }
            },
            showPieChart() {
                this.chartData = [];
                const paramMap = {
                    'qxxn': this.ksnf,
                    'zydm': this.zydm,
                    'xz': this.xz,
                }
                this.$api.teachingManage.teachingScheme.showPieChart({
                    data: paramMap,
                }).then((response) => {
                    let chartData = response.data.data.chartData;
                    this.chartData = chartData[0];
                    this.pieChartDialogVisible = true;
                    this.progressTypeDialogVisible = false;
                }).catch((error) => {
                    console.log(error);
                });
            },
            showProgressType(){
                this.pieChartDialogVisible = false;
                this.progressTypeDialogVisible = true;
            },
            closeProgressTypeDialog(){
                this.progressTypeDialogVisible = false;
            }
        }
    };
</script>
<style scoped>
    .tabArea /deep/ .el-tabs__header {
        padding: 0;
        position: relative;
        margin: 0;
    }
    .chartStyle {
        width:820px;
        height:500px;
        margin-top:20px;
        margin-left:20px;
        background:#eeeeee;
    }
</style>



// WEBPACK FOOTER //
// progressStatistics.vue?672a3f3e